export const hasAnchorAncestorOrSelf = (el: HTMLElement | null): boolean => {
  while (el?.parentElement) {
    if (el.tagName === 'A') {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};
